import Head from 'next/head';
import { type ComponentProps } from 'react';

import { env } from '~/env';

type SeoProps = ComponentProps<'div'> & {
  title?: string;
  description?: string;
  lang?: string;
  image?: string;
  pathname?: string;
  host?: string;
};

const defaultSeo = {
  description:
    'Grow your network, reuse effective outreach templates, compose better messages, share and track sent documents',
  image: 'https://cdn.useposeidon.com/ogImage.png',
  title: 'Poseidon',
  url: env.NEXT_PUBLIC_BACKEND_URL,
  twitterUsername: undefined,
};

const SEO = ({ description, image, title, host }: SeoProps) => {
  const siteTitle = title || defaultSeo.title;

  // Check if host matches *.farther.com
  const isFarther = host != null && /^([^.]+\.)*farther\.com/i.test(host);
  // const isFarther = host != null && /^localhost:3000$/i.test(host);

  return (
    <Head>
      <link rel="manifest" href="/manifest.json" id="manifest" />
      <meta name="theme-color" content="#123c9a" />
      <meta name="description" content={description} />
      {(defaultSeo.image || image) && <meta name="image" content={image || defaultSeo.image} />}
      <title>{siteTitle}</title>
      {siteTitle && <meta property="og:title" content={siteTitle} />}
      {siteTitle && <meta name="twitter:title" content={siteTitle} />}
      {description && <meta property="og:description" content={description} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      {defaultSeo.url && <meta property="og:url" content={defaultSeo.url} />}
      {defaultSeo.twitterUsername && <meta name="twitter:creator" content={defaultSeo.twitterUsername} />}
      {(defaultSeo.image || image) && <meta property="og:image" content={image || defaultSeo.image} />}
      {(defaultSeo.image || image) && <meta name="twitter:image" content={image || defaultSeo.image} />}
      {isFarther ? (
        <>
          <link rel="apple-touch-icon" sizes="180x180" href="/farther-favicon-large.jpg" />
          <link rel="icon" href="/farther-favicon.jpg" />
        </>
      ) : (
        <>
          <link rel="apple-touch-icon" sizes="180x180" href="/favicon-180x180.png" />
          <link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32" />
          <link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16" />
        </>
      )}
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
    </Head>
  );
};

export { SEO };
